import React from 'react';
import { Check } from 'lucide-react';
import { STEPS } from '../../../lib/producerPage.js';

/**
 * Seven-step progress bar. Completed steps are clickable so the agent can go back.
 * @param {{current: number, onGo: (index: number) => void}} props
 */
export default function Stepper({ current, onGo }) {
  return (
    <ol className="flex items-center gap-2 overflow-x-auto pb-1" aria-label="Producer page setup steps">
      {STEPS.map((s, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <li key={s.id} className="flex items-center gap-2 whitespace-nowrap" aria-current={active ? 'step' : undefined}>
            <button
              type="button"
              disabled={!done}
              onClick={() => onGo(i)}
              className="flex items-center gap-2 disabled:cursor-default"
              data-testid={`pp-step-${s.id}`}
            >
              <span className={`flex h-6 w-6 items-center justify-center rounded-full text-[11px] font-bold ${done || active ? 'bg-civix-purple text-white' : 'bg-white/10 text-white/50'}`}>
                {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
              </span>
              <span className={`text-xs ${active ? 'font-semibold text-white' : 'text-white/60'}`}>{s.label}</span>
            </button>
            {i < STEPS.length - 1 && <span className="hidden h-px w-6 bg-white/15 sm:block lg:w-10" aria-hidden="true" />}
          </li>
        );
      })}
    </ol>
  );
}
